var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#D85353",
    stroke: "#D24747"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2727 12.0001L17.1363 8.13643C17.4879 7.78486 17.4879 7.21533 17.1363 6.86377C16.7848 6.51221 16.2152 6.51221 15.8637 6.86377L12 10.7274L8.13633 6.86377C7.78477 6.51221 7.21524 6.51221 6.86368 6.86377C6.51212 7.21533 6.51212 7.78486 6.86368 8.13643L10.7273 12.0001L6.86368 15.8638C6.51212 16.2153 6.51212 16.7849 6.86368 17.1364C7.03946 17.3122 7.26973 17.4001 7.50001 17.4001C7.73028 17.4001 7.96055 17.3122 8.13633 17.1364L12 13.2728L15.8637 17.1364C16.0395 17.3122 16.2697 17.4001 16.5 17.4001C16.7303 17.4001 16.9606 17.3122 17.1363 17.1364C17.4879 16.7849 17.4879 16.2153 17.1363 15.8638L13.2727 12.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleclose);
export default __webpack_public_path__ + "static/media/circleclose.c077037ffd1918c5e351dc6288dfafe1.svg";
export { ForwardRef as ReactComponent };